module.exports = __webpack_public_path__ + "static/media/taggis-and-docbrowser.4c48a0ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taggis-and-docbrowser.jpg
// module id = 94
// module chunks = 3